<template>
    <div  ref="deliverlight" id="homeBox">
        <div class="jjTitle" >
            <div>
                <el-button type="primary" :disabled="disabled" size="mini" @click="add">新增</el-button>
                <el-button type="primary" :disabled="disabled||(!isEdit)" size="mini" @click="edit">编辑</el-button>
                <el-button type="success" :disabled="(!disabled)&& isEdit" size="mini" @click="editSave">{{$t('button_save')}}</el-button>
            </div>
        </div>
        <div class="jjBody">
            <el-table ref="table" :data="tableData" style="width: 78%"  size="mini" :stripe="true" highlight-current-row
                   :height="tableHeight"   :header-cell-style="{background:'#eef1f6',color:'black'}">
                <el-table-column type="index" :label="$t('form_serial_number')"></el-table-column>
                <el-table-column property="vc_name" label="名称" >
                    <template slot-scope="scope">
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{scope.row.vc_name}}</span>
                        <el-input v-else-if="isSave &&(scope.row.i_id===0)" v-model="scope.row.vc_name"　
                                  placeholder="请输入内容"></el-input>
                        <el-input v-else v-model="scope.row.vc_name" placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column property="dt_starttime" label="开始日期"  >
                    <template slot-scope="scope">
                        <!--         这个是查询作为展示-->
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{scope.row.dt_starttime}}</span>
                        <!--      这个是新增-->
                        <el-date-picker v-else-if="isSave &&(scope.row.i_id===0)"
                                        v-model="scope.row.dt_starttime" value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                        <!--       这个是编辑修改-->
                        <el-date-picker v-else
                                        v-model="scope.row.dt_starttime" value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column property="dt_endtime" label="结束日期" >
                    <template slot-scope="scope">
                        <!--            这个是查询作为展示-->
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{scope.row.dt_endtime}}</span>
                        <!--               这个是新增-->
                        <el-date-picker v-else-if="isSave &&(scope.row.i_id===0)"
                                        v-model="scope.row.dt_endtime" value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                        <!--           这个是编辑修改-->
                        <el-date-picker v-else
                                        v-model="scope.row.dt_endtime" value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column property="i_iswork" label="出勤安排">
                    <template slot-scope="scope">
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{(scope.row.i_iswork)+''==='1'?'班':'假'}}</span>
                        <el-select v-else-if="isSave &&(scope.row.i_id===0)" v-model="scope.row.i_iswork"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.i_iswork"
                                    :label="item.vc_iswork"
                                    :value="item.i_iswork">
                            </el-option>
                        </el-select>
                        <el-select v-else v-model="scope.row.i_iswork" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.i_iswork"
                                    :label="item.vc_iswork"
                                    :value="item.i_iswork">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_setup" label="是否启用">
                    <template slot-scope="scope">
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{(scope.row.i_setup)+''==='-1'?'否':'是'}}</span>
                        <el-select v-else-if="isSave &&(scope.row.i_id===0)" v-model="scope.row.i_setup"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in options1"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                        <el-select v-else v-model="scope.row.i_setup" placeholder="请选择">
                            <el-option
                                    v-for="item in options1"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_islegal" label="是否法假">
                    <template slot-scope="scope">
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{scope.row.i_islegal?'是':'否'}}</span>
                        <el-select v-else-if="isSave &&(scope.row.i_id===0)" v-model="scope.row.i_islegal"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in YoN"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                        <el-select v-else v-model="scope.row.i_islegal" placeholder="请选择">
                            <el-option
                                    v-for="item in YoN"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_isovertime" label="是否自动生成加班">
                    <template slot-scope="scope">
                        <span v-if="!disabled && (isSave||scope.row.i_id!==0)">{{scope.row.i_isovertime?'是':'否'}}</span>
                        <el-select v-else-if="isSave &&(scope.row.i_id===0)" v-model="scope.row.i_isovertime"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in YoN"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                        <el-select v-else v-model="scope.row.i_isovertime" placeholder="请选择">
                            <el-option
                                    v-for="item in YoN"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="dt_createtime" label="录入时间"></el-table-column>
            </el-table>
        </div>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.pageNum"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="pageSize"
                            layout="total,sizes"
                            :total="totalNum"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageNum"
                            :page-size="pageSize"
                            layout="prev, pager, next, jumper"
                            :total="totalNum">
                    </el-pagination>
                </div>
            </div>
        </div>
<!--        <div class="pages">-->
<!--            <div class=" choosepage flexother mrt20 fl">-->
<!--                <el-pagination style="position: absolute;right: 0px"-->
<!--                               @size-change="handleSizeChange"-->
<!--                               @current-change="handleCurrentChange"-->
<!--                               :current-page="pageNum"-->
<!--                               :page-size="pageSize"-->
<!--                               layout="total, prev, pager, next, jumper"-->
<!--                               :total="totalNum">-->
<!--                </el-pagination>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>
<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "JieJiaRi",
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                i_kqtcid:0,
                disabled: false,
                isEdit: true,
                tableHeight:0,
                isSave: false,//新增按钮操作对新增的一条进行可编辑操作
                dialogVisible: false,
                tableData: [],
                tableDataCopy: [],
                pageNum: 1,//当前页码
                pageSize: 10,//页码条数
                totalNum: 20,//总页码数量
                date: '',
                baseerp:'',
                options: [{
                    i_iswork: 1,
                    vc_iswork: '班'
                }, {
                    i_iswork: 0,
                    vc_iswork: '假'
                }],
                options1: [{
                    i_setup: 1,
                    vc_setup: '是'
                }, {
                    i_setup: -1,
                    vc_setup: '否'
                }],
                YoN: [{
                    i_setup: 1,
                    vc_setup: '是'
                }, {
                    i_setup: 0,
                    vc_setup: '否'
                }],
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            formvalue:{
                handler(){
                    if (this.formvalue){
                        // console.log(this.formvalue,11);
                        this.i_kqtcid=this.formvalue.i_id;
                        this.vc_djmark=this.formvalue.vc_djmark;
                        this.isEdit = this.isSave = true;

                        // console.log(this.i_kqtcid)
                        this.search()
                        //this.formData.i_id=this.formvalue.i_id;
                        // this.formData.vc_tcname=this.formvalue.vc_tcname;
                        // this.formData.vc_djmark=this.formvalue.vc_djmark;
                        // this.formData.i_start=this.formvalue.i_start;
                        // this.formData.i_end=this.formvalue.i_end;
                        // this.formData.vc_lruname=this.formvalue.vc_createuser;
                        // this.formData.date=this.formvalue.dt_createtime;
                    }
                },
                immediate:true,
                deep:true
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp
            this.search();
            this.getDateYYYYMMddHHMMSS();
            this.$nextTick(function () {
                this.onResize();

            });
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h-120);
                $("#homeBox").width(n.w);
                // $("#eltable").width(n.w-260);

                this.tableHeight= n.h-155
                // eltable
                // console.log(n.h-500)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            ...mapActions(["getCurrentMenuId"]),
            heightAuto() {
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            deepClone1(obj) {  //判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
                let objClone = Array.isArray(obj) ? [] : {};
                //进行深拷贝的不能为空，并且是对象或者是
                if (obj && typeof obj === "object") {
                    for (let key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            if (obj[key] && typeof obj[key] === "object") {
                                objClone[key] = this.deepClone1(obj[key]);
                            } else {
                                objClone[key] = obj[key];
                            }
                        }
                    }
                }
                return objClone;
            },
            //查询接口
            async search() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    page_size: this.pageNum,
                    page_count: this.pageSize,
                    i_kqtcid:this.i_kqtcid,
                }
                let res = await API.search(params);
                if (res.code == 1) {

                    this.tableData = res.data;
                    this.totalNum = res.count;
                    this.tableDataCopy = this.deepClone1(this.tableData);
                     // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {

                    this.$message.error(res.message);
                }
            },
            //保存接口
            async save(data) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                for (const item of data) {
                    let params = {
                        i_id: item.i_id !== 0 ? item.i_id : 0,
                        vc_name: item.vc_name,
                        dt_starttime:item.dt_starttime,
                        dt_endtime: item.dt_endtime,
                        vc_iswork: item.vc_iswork,
                        i_iswork: item.i_iswork,
                        i_islegal: item.i_islegal,
                        i_isovertime: item.i_isovertime,
                        i_setup: item.i_setup,
                         vc_lrunname: sessionStorage.getItem('lrunname'),
                        i_kqtcid:this.i_kqtcid,
                        vc_djmark:this.vc_djmark
                    }
                    let res = await API.save(params);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        this.search();
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                        this.search();
                    } else {
                        this.search();
                        this.$message.error(res.message);
                    }
                }
            },
            getDateYYYYMMddHHMMSS() {
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date = `${date.getFullYear()}-${month}-${strDate}`;
                // console.log(this.formData.date)
            },
            handleSizeChange(pageSize) {
                this.pageSize = pageSize;
                this.search()
            },
            handleCurrentChange(pageNum) {
                this.pageNum = pageNum;
                this.search();
            },
            add() {
                const newLine = {
                    i_id: 0,
                    vc_name: '',
                    dt_starttime: '',
                    dt_endtime: '',
                    i_iswork: '',
                    i_isovertime:'',
                    i_islegal:'',
                    i_setup: '',
                    dt_createtime: this.date
                }
                this.tableData.unshift(newLine);
                this.isEdit = this.isSave = false;
            },
            //编辑切换按钮状态
            edit() {
                this.disabled = !this.disabled;
            },
            recursion(data, data1,index) {
                for (let i in data) {
                    if (typeof data[i] === 'object' && data[i] !== null) {
                        return this.recursion(data[i], data1[i])
                    } else {
                        if (data[i] !== data1[i]) {
                            return true
                        }
                    }
                }
            },
            //保存按钮
            editSave() {
                if (this.isEdit) {
                    let data = this.tableData.filter((data, i) => {
                        return this.recursion(data,this.tableDataCopy[i],i) || false
                    });
                    for (let i of data) {
                        if (i.dt_starttime === '' || i.dt_starttime === null) { //必须不为空才能判断大小
                            this.$message({
                                type: "error",
                                message: "开始日期不能为空",
                            })
                            return
                        }
                        if (i.dt_endtime === '' || i.dt_endtime === null) {
                            this.$message({
                                type: "error",
                                message: "结束日期不能为空！",
                            })
                            return
                        }
                        if (new Date(i.dt_starttime).getTime()>new Date(i.dt_endtime).getTime()){
                            this.$message({
                                type: "error",
                                message: "开始日期不能大于等于结束日期",
                            })
                            return
                        }
                        if (i.vc_name === '') {
                            this.$message({
                                type: "error",
                                message: "名称不能为空！",
                            })
                            return
                        }
                        if (i.i_iswork === '') {
                            this.$message({
                                type: "error",
                                message: "出勤安排不能为空！",
                            })
                            return
                        }
                        if (i.i_isovertime === '') {
                            this.$message({
                                type: "error",
                                message: "是否自动生成加班不能为空！",
                            })
                            return
                        }
                        if (i.i_islegal === '') {
                            this.$message({
                                type: "error",
                                message: "是否法假不能为空！",
                            })
                            return
                        }
                        if (i.i_setup === '') {
                            this.$message({
                                type: "error",
                                message: "是否启用不能为空！",
                            })
                            return
                        }
                    }
                    this.save(data)
                }else{
                    //保存时
                    let data = []
                    for (let i of this.tableData) {
                        if (i.i_id === 0) {
                            if (i.dt_starttime === '' || i.dt_starttime === null) { //必须不为空才能判断大小
                                this.$message({
                                    type: "error",
                                    message: "开始日期不能为空",
                                })
                                return
                            }
                            if (i.dt_endtime === '' || i.dt_endtime === null) {
                                this.$message({
                                    type: "error",
                                    message: "结束日期不能为空！",
                                })
                                return
                            }
                            if (new Date(i.dt_starttime).getTime()>new Date(i.dt_endtime).getTime()){
                                this.$message({
                                    type: "error",
                                    message: "开始日期不能大于等于结束日期",
                                })
                                return
                            }
                            if (i.vc_name === '') {
                                this.$message({
                                    type: "error",
                                    message: "名称不能为空！",
                                })
                                return
                            }
                            if (i.i_iswork === '') {
                                this.$message({
                                    type: "error",
                                    message: "出勤安排不能为空！",
                                })
                                return
                            }
                            if (i.i_isovertime === '') {
                                this.$message({
                                    type: "error",
                                    message: "是否自动生成加班不能为空！",
                                })
                                return
                            }
                            if (i.i_islegal === '') {
                                this.$message({
                                    type: "error",
                                    message: "是否法假不能为空！",
                                })
                                return
                            }
                            if (i.i_setup === '') {
                                this.$message({
                                    type: "error",
                                    message: "是否启用不能为空！",
                                })
                                return
                            }
                            data.push(i)
                        }
                    }
                    this.save(data)
                }
                this.disabled = false;//切换按钮状态
                this.isEdit = this.isSave = true;
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.heightAuto)
        },
    }
</script>

<style  lang="scss" scoped>
    .jjTitle {
        height: 60px;
        position: relative;
    }

    .jjTitle > div {
        display: inline-block;
        position: absolute;
        /*left: 20px;*/
        top: 10px;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 28px;
            width: 46px;
            margin:12px 0 0 10px;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }

    /*.mrt20{*/
    /*    !*margin-top: 20px;*!*/
    /*}*/
    .mrl20{
        margin-left: 20px;
    }
    .mrb20{
        margin-right: 20px;
    }
    .mrr20{
        margin-right: 20px;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        width:73%
    }

    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }



    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    /deep/{
        /*.mrt20{*/
        /*    height: 50px !important;*/
        /*}*/
        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }


    }
    .fenye{
         height: 50px;
     }
    /*#pane-3{*/
    /*    height: 700px;*/
    /*}*/
    /deep/{
        .el-tabs__content{
            height: 90%;
            overflow: visible !important;
            height:calc(100% - 5px) !important;
        }
        /*.el-button--success.is-disabled, .el-button--success.is-disabled:active, .el-button--success.is-disabled:focus, .el-button--success.is-disabled:hover{*/
        /*    background-color:rgb(206,205,200) ;*/
        /*}*/
        /*.el-button--success{*/
        /*    background-color: rgb(72,182,87);*/
        /*}*/
    }
    .all {
        width: 100%;
    }
    .flex-c-a {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .margin-top-10 {
        margin-top: 10px;
    }
    .base-form.el-form-item__content {
        margin-left: 0;
    }
    .add-btn {
        color: #4077F4;
    }
    .delete-btn {
        color: #f56c6c;
    }

    /*.choosepage{*/
    /*    width:90%*/
    /*}*/
    /*.flexother {*/
    /*    display: flex;*/
    /*    flex-flow: wrap;*/
    /*    justify-content: space-between;*/
    /*    align-items: center;*/
    /*}*/
    /*.mrt20{*/
    /*    margin-top: 20px;*/
    /*}*/
    /*.fl{*/
    /*    float: left;*/

    /*.el-button--primary{*/
    /*    color: #efd773;*/
    /*    background-color:white;*/
    /*    border: 0;*/
    /*    text-align: center;*/
    /*    padding: 0;*/
    /*    height: 28px;*/
    /*    width: 46px;*/
    /*    margin:12px 0 0 10px;*/
    /*}*/
    /*}*/
    /*.jjBody {*/
    /*    width: 100%;*/
    /*    height: 600px;*/

    /*}*/

    /*.fenye > div {*/
    /*    display: inline-block;*/
    /*}*/

    /*.fenye > span {*/
    /*    position: absolute;*/
    /*    right: 350px;*/
    /*    display: inline-block;*/
    /*    margin-top: 20px;*/
    /*}*/
</style>